@if (policies) {
  <div class="grid-x">
    @if (!externalView) {
      <div class="cell small-12">
        <h4 class="bold">{{ orgName }}</h4>
      </div>
    }
    <div class="cell medium-5">
      <div class="grid-x">
        <div class="cell small-8">
          <h2 class="h5 no-margin">Insurance Required:</h2>
          <p class="h2 bold">
          {{requiredInsuranceAmount}}</p>
        </div>
        <div class="cell small-4">
          @if (insuranceDecisionBasis) {
            <span class="no-margin no-padding display-inline-block"
              [popover]="{ text: insuranceDecisionBasis, position: 'top' }">
              <svg-icon icon="icon-info" class="small dark-gray"></svg-icon>
            </span>
          }
        </div>
      </div>
    </div>
    <div class="cell medium-5">
      <h2 class="h5 no-margin"  [ngClass]="{ 'red': !isCompliant }">Insurance Provided:</h2>
      <p class="h2 bold" [ngClass]="{ 'red': !isCompliant }" >{{activeInsuranceAmount}}</p>
    </div>
    <div class="cell medium-2 text-align-right">
      @if (canAddInsurance() && externalView) {
        <button class="button" (click)="addInsurance()" aria-label="Add Insurance">Add Insurance</button>
      }
      <button (click)="recalculate()" class="button">Recalculate</button>
    </div>
    <div class="cell small-12"><p class="small-font-size italic no-margin">The amount of financial assurance listed does not include any additional financial assurance that may additionally be required as a result of a court order, chief's order, compliance agreement, or a temporary inactive status authorization</p></div>
  </div>
}
<div class="grid-x">
  <ag-grid-angular [gridOptions]="gridOptions" [rowData]="policies" class="data-grid " [attr.aria-label]="gridAriaLabel"></ag-grid-angular>
</div>
